module.exports = __webpack_public_path__ + "8f4068ba480893c081d76aba03ccaa20.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/public/data-deletion-form/data-deletion-form.html
// module id = 2275
// module chunks = 0